module.exports = __webpack_public_path__ + "assets/b04b90b0283e000741d90ea5cd6f1390.png";